/** @file The viewport's opening notice for a project with images but no slots: Auto-rig builds the rig. */
import type { Doc } from '@pose2d/format/types';
import type { ViewportNotice } from './viewportTypes';

/**
 * Imported images alone leave the viewport empty (image.importLayers creates no slots). After "New project from PSD…"
 * the import dialog closes as the editor opens, so the editor itself names the next step, with a button that runs it.
 */
export function autorigHint(doc: Doc): ViewportNotice | null {
  const images = Object.keys(doc.images).length;
  if (images === 0 || Object.keys(doc.slots).length > 0) return null;
  return { kind: 'offer', key: 'viewport.autorigHint', params: { n: images }, action: 'autoRig' };
}
